var places = [
  {
    selectId: 'A',
    selectRow: 'select01',
    selecttranslate: 'translate(387.82 124)',
    fontsize: '25',
  },
  {
    selectId: 'B',
    selectRow: 'select01',
    selecttranslate: 'translate(425.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'B',
    selectRow: 'select02',
    selecttranslate: 'translate(445.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'B',
    selectRow: 'select03',
    selecttranslate: 'translate(435.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'B',
    selectRow: 'select04',
    selecttranslate: 'translate(430.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'B',
    selectRow: 'select05',
    selecttranslate: 'translate(410.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'B',
    selectRow: 'select06',
    selecttranslate: 'translate(425.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'B',
    selectRow: 'select07',
    selecttranslate: 'translate(407.82 234)',
    fontsize: '22',
  },
  {
    selectId: 'C',
    selectRow: 'select01',
    selecttranslate: 'translate(775.658 330.773)',
    fontsize: '25',
  },
  {
    selectId: 'D',
    selectRow: 'select01',
    selecttranslate: 'translate(387.82 417)',
    fontsize: '25',
  },
  {
    selectId: 'E',
    selectRow: 'select01',
    selecttranslate: 'translate(60.120 175.773)',
    fontsize: '23',
  },
  {
    selectId: 'F',
    selectRow: 'select01',
    selecttranslate: 'translate(742.300 175.773)',
    fontsize: '23',
  },
]

// コンバイン追加 click4を元にデータ復元とやり直しのデータセットに対応 start
let originals = [
  {
    selectId: 'A',
    transform: 'translate(527.82 128.672)',
    innerHTML: '<tspan class="textpointer" x="-10.176" y="0">a</tspan>',
  },
  {
    selectId: 'B',
    transform: 'translate(530 239)',
    innerHTML: '<tspan class="textpointer" x="-11.758" y="0">b</tspan>',
  },
  {
    selectId: 'C',
    transform: 'translate(900.5 335.375)',
    innerHTML: '<tspan id="rect_62" class="rect_6-2" x="-11.777" y="0">c</tspan>',
  },
  {
    selectId: 'D',
    transform: 'translate(530.175 424.125)',
    innerHTML: '<tspan id="rect_63" class="rect_6-3" x="-10.459" y="0">d</tspan>',
  },
  {
    selectId: 'E',
    transform: 'translate(180.144 180.773)',
    innerHTML: '<tspan id="rect_64" class="rect_6-4" x="0" y="0">e</tspan>',
  },
  {
    selectId: 'F',
    transform: 'translate(872.658 180.773)',
    innerHTML: '<tspan id="rect_65" class="rect_6-5" x="-11.777" y="0">f</tspan>',
  }
]

function restore(selectedId, dataName) {
  var elmTextCon = document.getElementById(selectedId + '-text')
  var elemId = document.querySelector("rect[data-name='" + dataName + "']").id
  var selectedtransLate
  var fontSize
  if (selectedId == 'B') {
  } else {
    elemId = 'select01'
  }
  places.forEach(function (keys) {
    if (keys.selectId == selectedId && keys.selectRow == elemId) {
      fontSize = keys.fontsize
      selectedtransLate = keys.selecttranslate
    }
  })
  elmTextCon.textContent = dataName
  elmTextCon.setAttribute('font-size', fontSize)
  elmTextCon.setAttribute('transform', selectedtransLate)
}

function clear(selectedId) {
  var elmTextCon = document.getElementById(selectedId + '-text')
  var transform
  var fontSize = '40'
  var innerHTML
  originals.forEach(function (keys) {
    if (keys.selectId == selectedId) {
      transform = keys.transform
      innerHTML = keys.innerHTML
    }
  })
  elmTextCon.setAttribute('font-size', fontSize)
  elmTextCon.setAttribute('transform', transform)
  elmTextCon.innerHTML = innerHTML
}
// コンバイン追加 click4を元にデータ復元とやり直しのデータセットに対応 end

export { restore, clear }
